import React from 'react';
import { Bell, Shield, Briefcase } from 'lucide-react';

export type NotificheArea = { notificheFiduciari: boolean; notificheInvestigativi: boolean };

type Props = {
    value: NotificheArea;
    onChange: (next: NotificheArea) => void;
    disabled?: boolean;
};

/**
 * Avvisi da supervisore per area (titolare e responsabile): turni rifiutati o non avviati,
 * report mancanti, budget superato e simili. Le notifiche personali sui propri lavori restano.
 */
export default function NotificheAreaToggles({ value, onChange, disabled }: Props) {
    const riga = (key: keyof NotificheArea, label: string, icon: React.ReactNode, on: string) => {
        const attivo = value[key];
        return (
            <div className="flex justify-between items-center gap-3">
                <span className="text-sm text-gray-700 flex items-center gap-2">{icon}{label}</span>
                <button
                    type="button"
                    role="switch"
                    aria-checked={attivo}
                    disabled={disabled}
                    onClick={() => onChange({ ...value, [key]: !attivo })}
                    className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${attivo ? on : 'bg-gray-300'}`}
                >
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${attivo ? 'translate-x-6' : 'translate-x-1'}`} />
                </button>
            </div>
        );
    };
    const nessuna = !value.notificheFiduciari && !value.notificheInvestigativi;
    return (
        <div className="p-3 border rounded-lg bg-gray-50 space-y-3">
            <p className="text-xs font-bold text-gray-500 uppercase flex items-center gap-1.5"><Bell size={12}/> Avvisi da supervisore</p>
            {riga('notificheFiduciari', 'Notifiche servizi fiduciari', <Shield size={14} className="text-emerald-600"/>, 'bg-emerald-500')}
            {riga('notificheInvestigativi', 'Notifiche servizi investigativi', <Briefcase size={14} className="text-indigo-600"/>, 'bg-indigo-500')}
            {nessuna && (
                <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded p-2">
                    Con entrambe disattivate non riceverai avvisi su turni e incarichi.
                </p>
            )}
        </div>
    );
}
